import { Upload, Space, Popover, App } from 'antd'
import { UploadOutlined, InfoCircleOutlined } from '@ant-design/icons'
import PresetBumpmapPicker from './PresetBumpmapPicker'
import BumpmapPreview from './BumpmapPreview'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { checkFileSize } from '$utils'
import { evoConsolidation } from '$api'
import PropTypes from 'prop-types'
import {
  ACCEPTED_BUMPMAP_FILE_TYPES,
  IMAGE_FORMATS,
  GRAPHIC_FORMATS,
  TEXT_FORMATS,
} from '$constants'

const StyledDragger = styled(Upload.Dragger)`
  .ant-upload,
  .ant-upload-drag {
    height: auto !important;
  }
`

const BumpmapUpload = ({ imageFile, setImageFile, onRemove }) => {
  const { t } = useTranslation()
  const { message } = App.useApp()

  const handleUpload = ({ file }) => {
    if (checkFileSize(file.size, '10 MB', t)) {
      setImageFile({
        file: file,
        isPreset: false,
        presetName: null,
        textureId: null,
      })
    }
  }

  return imageFile.file ? (
    <BumpmapPreview imageFile={imageFile} onRemove={onRemove} />
  ) : (
    <StyledDragger
      showUploadList={false}
      beforeUpload={async (file) => {
        try {
          const formData = new FormData()
          formData.append('texture_file', file)

          await evoConsolidation.post(
            '/booked-services/apply-texturing/textures/validate-file',
            formData,
          )
        } catch {
          message.error(t('service.apply_texturing.invalid_texture_file_type'))
          return Upload.LIST_IGNORE
        }

        return false
      }}
      onChange={handleUpload}
      accept={ACCEPTED_BUMPMAP_FILE_TYPES.join(',')}
      style={{ height: 'auto' }}
    >
      <Space>
        <div>
          <UploadOutlined style={{ fontSize: 24 }} />
        </div>
        <div style={{ textAlign: 'left' }}>
          <div>{t('service.apply_texturing.drag_drop_or_choose_preset')}</div>
          <Popover
            title={t('service.apply_texturing.supported_formats')}
            content={
              <div>
                <div>
                  {t('service.apply_texturing.image_formats', {
                    formats: IMAGE_FORMATS,
                  })}
                </div>
                <div>
                  {t('service.apply_texturing.graphic_formats', {
                    formats: GRAPHIC_FORMATS,
                  })}
                </div>
                <div>
                  {t('service.apply_texturing.text_formats', {
                    formats: TEXT_FORMATS,
                  })}
                </div>
                <div>{t('service.apply_texturing.max_file_size')}</div>
              </div>
            }
          >
            <Space style={{ cursor: 'pointer', color: '#888', fontSize: 12 }}>
              <InfoCircleOutlined />
              {t('service.apply_texturing.file_info')}
            </Space>
          </Popover>
        </div>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          style={{ all: 'unset' }}
        >
          <PresetBumpmapPicker setImageFile={setImageFile} />
        </button>
      </Space>
    </StyledDragger>
  )
}

BumpmapUpload.propTypes = {
  imageFile: PropTypes.object.isRequired,
  setImageFile: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default BumpmapUpload
